import Joi from 'joi';

const dateValidator = Joi.extend({
  messages: {
    invalidDate: 'Formato de fecha inválido Ej: dd/mm/aaaa',
  },
  type: 'date',
  rules: {
    validateDate: {
      validate(value, helpers) {
        let pattern = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i;
        let res = pattern.test(value);
        if (res) return true;
        else return helpers.error('invalidDate');
      },
    },
  },
});

export const phoneNumberValidator = Joi.extend({
  messages: {
    invalidNumber: 'Número de teléfono consta de 9 dígitos',
  },
  type: 'phone',
  rules: {
    validateNumber: {
      validate(value, helpers) {
        const isNum = /^\d+$/.test(value);
        if (!isNum) return helpers.error('invalidNumber');
        if (value.length < 9 || value.length > 9)
          return helpers.error('invalidNumber');
        return true;
      },
    },
  },
});

export const schema = Joi.object({
  firstName: Joi.string()
    .min(3)
    .max(255)
    .error(new Error('Nombre de cliente requerido')),
  lastName: Joi.string()
    .min(3)
    .max(255)
    .error(new Error('Apellido de cliente requerido')),
  logonId: Joi.string().length(8).error(new Error('Dni consta de 8 dígitos')),
  dateOfBirth: dateValidator.date().validateDate(),
  phone1: phoneNumberValidator.phone().validateNumber(),
  email1: Joi.string()
    .min(3)
    .max(255)
    .email({ tlds: { allow: false } })
    .error(new Error('Correo electrónico es requerido')),
  gender: Joi.string(),
  middleName: Joi.string(),
});
